export default class User {
    returnModel() {
        return {
            middleName: null,
            id: null,
            idUserSuccessFactors: null,
            idCountry: null,
            idCompany: null,
            idDivision: null,
            idLocation: null,
            idJobCode: null,
            idCostCenter: null,
            hashMainDocument: null,
            firstName: null,
            lastName: null,
            userDomain: null,
            userName: null,
            email: null,
            lastRemoteIpAddress: null,
            usedRememberMeOption: null,
            isSystemUser: null,
            lastLogonDate: null,
            addDate: null,
            obsoleteDate: null,
            role: null,
            objectPrivileges: null
        }
    }
}